import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { FaCheckCircle } from 'react-icons/fa'; // Using a check-circle icon for success
import { useNavigate } from 'react-router-dom';
import AOS from 'aos'; // Import AOS for animation
import 'aos/dist/aos.css'; // Import AOS styles
import './SuccessMessage.scss';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
const SuccessMessage = ({ message, onReset }) => {
  const { translations, language, direction } = useLanguage();
  const t = translations;
  const navigate = useNavigate();
  useEffect(() => {
    // Initialize AOS animation
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <Box
      data-aos="fade-up" // AOS animation trigger
      sx={{
        textAlign: 'center',
        padding: '100px 20px',
        backgroundColor: '#f8fafb', // Light background for the success message
      }}
    >
      <FaCheckCircle
      className="not-found-icon" 
        style={{
          fontSize: '60px',
          color: 'var(--primary-color)', // Custom primary color for the icon
          marginBottom: '16px',
        }}
      />
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          color: 'var(--primary-color)', // Primary color for the heading
          mb: 2,
        }}
      >
        {message || t.priceRequestSuccess}
      </Typography>
      <Typography variant="body1" sx={{ color: '#676464', mb: 4 }}>
        {message ? t.successMessage2: t.conditionalMessage}
      </Typography>
      <Button
        variant="outlined"
        sx={{
          color: 'var(--primary-color)', // Custom primary color for the button
          borderColor: 'var(--primary-color)',
          borderRadius: '5px',
          display: 'inline-flex',
          alignItems: 'center',
          '&:hover': {
            borderColor: '#fff',
            backgroundColor: 'var(--primary-color)',
            color: '#fff',
          },
        }}
        onClick={onReset} // Handle reset logic
      >
        <FaCheckCircle style={{ marginRight: '8px' }} />
      {t.submitAnotherRequest}
      </Button>
  
    </Box>
  );
};

export default SuccessMessage;
